<script setup lang="ts">
import { Popup, showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { ref } from "vue";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useGalGameEditor();

const publishMomentText = ref("");
const onPublishStory = async () => {
  if (!publishMomentText.value) {
    showFailToast(t("Message.notWrittenIntro"));
    return;
  }
  try {
    await store.publishGalGame(publishMomentText.value);
    showSuccessToast(t("Message.publishSuccess"));
    store.showPublishModal = false;
  } finally {
  }
};
</script>
<template>
  <popup
    :show="store.showPublishModal"
    @update:show="store.showPublishModal = $event"
    position="center"
    class="py-10 px-10"
    round
    teleport="body"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-5">
      <div class="flex flex-col items-center justify-center gap-2">
        <i class="iconfont icon-script-game text-[40px] text-my-gray"></i>
        <div class="text-lg font-bold text-base-content/50">
          {{ $t("Texts.gamePublished") }}
        </div>
        <div class="text-base text-base-content/50">
          {{ $t("Texts.gamePublishedNotModified") }}
        </div>
      </div>
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ $t("Texts.introGame") }}</span>
          <textarea
            v-model="publishMomentText"
            class="textarea textarea-bordered"
            :placeholder="$t('Texts.gamePublishedPlaceholder')"
          />
        </div>
      </div>
      <div class="flex gap-2 justify-between items-center">
        <button
          class="btn rounded btn-primary btn-sm flex-1"
          @click="onPublishStory"
        >
          {{ $t("Buttons.publish") }}
        </button>
        <button
          class="btn rounded btn-sm flex-1"
          @click="store.showPublishModal = false"
        >
          {{ $t("Buttons.cancel") }}
        </button>
      </div>
    </div>
  </popup>
</template>
